import {RootState} from 'common/src/redux/store';
import {AgentContext} from '../../copilot.types';
import {RouteWithParams} from 'common/src/modules/routing/routing.types';
import routingService from 'common/src/modules/routing/routing.service';
import formatRouteDisplayString from 'common/src/modules/routing/utils/formatRouteDisplayString';

function currentRouteContext(getState: () => RootState): AgentContext<RouteWithParams | null> {
  return {
    title: 'Current Page',
    getter,
    formatter,
  };

  function getter(): RouteWithParams | null {
    return routingService.getCurrentRouteWithParams();
  }

  function formatter({
    prevContext,
    currentContext: currentRoute,
  }: {
    prevContext: RouteWithParams | null;
    currentContext: RouteWithParams | null;
  }): string | null {
    if (!currentRoute) {
      return null;
    }

    const formatted = formatRouteDisplayString(currentRoute, getState);

    if (!formatted) {
      return null;
    }

    const prefix = prevContext
      ? "The user's location has changed to"
      : "The user's current location";

    return `${prefix}: ${formatted}`;
  }
}

export default currentRouteContext;
